import * as Sentry from '@hy-sentry/browser';
import { Integrations } from '@hy-sentry/tracing';

window.disableKiwiSentry = true;

function getCookie(cookieName) {
  const cookieString = document.cookie;
  const cookies = cookieString.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    let start = cookie.indexOf(cookieName + '=');
    if (start == -1 || start > 1) continue;
    start += cookieName.length + 1;
    return cookie.substring(start);
  }
  return null;
}

Sentry.init({
  dsn: 'https://ae9179b25c8742039df7dd47ac41815a@fems.huya.com/1179',
  integrations: [new Integrations.BrowserTracing({ notTracingRemote: true })],
  debug: false,
  sampleRate: 1,
  release: 'tiger-huya-video-player',
  initialScope: {
    tags: { 'uid': getCookie('udb_uid') }
  }
});

window.Sentry = Sentry;
